import { AUTH_FAILURE_UNAUTHORIZED } from '../reducers/auth.reducer';
import { put } from 'redux-saga/effects';

export function* handleError(
  response,
  defaultMessage = 'Something went wrong'
) {
  let message;

  switch (response.status) {
    case 500:
      message = 'Internal Server Error';
      break;
    case 401:
      message = 'Invalid credentials';
      yield put({ type: AUTH_FAILURE_UNAUTHORIZED, payload: message });
      break;
    case 422:
      message = 'Invalid form data or some names already taken';
      break;
    default:
      message = defaultMessage;
  }

  return message;
}



// WEBPACK FOOTER //
// ./src/sagas/helper.js